// @noflow
import type { Language } from '@/packs/localisation'
import initI18n from '@/packs/localisation'
import i18next from 'i18next'

type Tab = {
  title: string
  tabTitle: string
  hash: string
  pathname: string
  translation_key: string
}

const initTabs = ({
  preferredLanguage
}: {
  preferredLanguage: Language
}): Tab[] => {
  if (!i18next.isInitialized) initI18n(preferredLanguage)

  const dashboardPathName = i18next.t('routes:dashboard')
  const summaryPathName = i18next.t('routes:summary')
  const referralsPathName = i18next.t('routes:referrals')
  const merchPathName = i18next.t('routes:merch')
  const balancePathName = i18next.t('routes:balance')
  const contactPathName = i18next.t('routes:contact')

  return [
    {
      title: 'Your Summary',
      tabTitle: 'Summary',
      hash: 'summary',
      pathname: `/${dashboardPathName}/${summaryPathName}`,
      translation_key: 'ambassadors:dashboard.tabs.your_summary'
    },
    {
      title: 'Refer a Client',
      tabTitle: 'Refer',
      hash: 'refer',
      pathname: `/${dashboardPathName}/${referralsPathName}`,
      translation_key: 'ambassadors:dashboard.tabs.refer_a_client'
    },
    {
      title: 'Free Merch',
      tabTitle: 'Merch',
      hash: 'merch',
      pathname: `/${dashboardPathName}/${merchPathName}`,
      translation_key: 'ambassadors:dashboard.tabs.free_merch'
    },
    {
      title: 'Balance',
      tabTitle: 'Balance',
      hash: 'balance',
      pathname: `/${dashboardPathName}/${balancePathName}`,
      translation_key: 'ambassadors:dashboard.tabs.balance'
    },
    {
      title: 'Contact',
      tabTitle: 'Contact',
      hash: 'contact',
      pathname: `/${dashboardPathName}/${contactPathName}`,
      translation_key: 'ambassadors:dashboard.tabs.contact'
    }
  ]
}

const shopTab: Tab[] = [
  {
    title: 'Visit Shop',
    tabTitle: 'Shop',
    hash: 'shop',
    pathname: '',
    translation_key: 'ambassadors:dashboard.tabs.visit_shop'
  }
]

export { initTabs, shopTab }
